<template>
  <div>
    <el-card>
      <el-row :gutter="20" class="mb-20">
        <el-col :span="6">
          <el-select v-model="selectedGame" placeholder="请选择游戏" @change="handleGameChange">
            <el-option
              v-for="game in gameOptions"
              :key="game.value"
              :label="game.label"
              :value="game.value"
            />
          </el-select>
        </el-col>
      </el-row>

      <el-table :data="gamePlayList" border style="width: 100%; max-height: 600px; overflow-y: auto;">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="期数" />
        <el-table-column prop="odds" label="开奖结果">
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template #default="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'danger'">
              {{ row.status === 1 ? '开奖' : '未开奖' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="更新时间" width="220">
          <template #default="{ row }">
            {{ row.time }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="150">
          <template #default="{ row }">
            <el-button type="primary" size="small" @click="handleSave(row)">保存</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <el-pagination
        :current-page="pagination.page"
        :page-size="pagination.limit"
        :total="total"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getGameOddsList, getGameResult,updateGameOdds } from '@/api/game';
import { getLotteryGames } from '@/api/lotteryGame';


export default {
  data() {
    return {
      selectedGame: '',
      gameOptions: [
        // { value: '1', label: '重庆时时彩' },
        // { value: '2', label: '北京赛车' },
        // { value: '3', label: '幸运飞艇' }
      ],
      gamePlayList: [],
      pagination: {
        page: 1,
        limit: 20
      },
      total: 0
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
if (!this.selectedGame) return;

const params = {
  gameId: this.selectedGame,
  page: this.pagination.page,
  limit: this.pagination.limit
};
const { data } = await getGameResult(params);
this.gamePlayList = data.rows.map(item => ({
  id: item.id,
  name: item.issue,
  odds: JSON.stringify(item.result), // 将赔率转换为数字
  status: item.status ? 1 : 0, // 将状态转换为 1 或 0
  time: item.updated_at
}));
this.total = data.count;
},
    handleGameChange() {
      this.pagination.page = 1;
      this.fetchData();
    },
    handlePageChange(page) {
      this.pagination.page = page;
      this.fetchData();
    },
    async handleSave(row) {
      try {
        await updateGameOdds(row.id, { odds: row.odds });
        this.$message.success('保存成功');
      } catch (error) {
        this.$message.error('保存失败');
      }
    }
  },
  async mounted() {
    try {
      const {data} = await getLotteryGames();
      console.log('沆试',data)
      console.log(data.rows);
      this.gameOptions = data.rows.map(game => ({
        value: game.id,
        label: game.name
      }));
    } catch (error) {
      console.error('获取游戏列表失败:', error);
    }
  }
};
</script>

<style scoped>
.el-card {
  margin: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>